/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';

// Added for QA Purposes
const defaultTimeout = window.sessionStorage.getItem('AGENT_QUEUE_TIMEOUT_SECONDS')
  ? parseInt(window.sessionStorage.getItem('AGENT_QUEUE_TIMEOUT_SECONDS'), 10)
  : 600;

function useTimer(timeoutSeconds = defaultTimeout, store = true) {
  const storageName = 'agent_queue_start';
  const [startTime, setStartTime] = useState(false);
  const [isTimerFinished, setIsTimerFinished] = useState(false);
  const [intervalHandler, setIntervalHandler] = useState(null);

  const getElapsedTimeSeconds = start => {
    const now = new Date().getTime();
    const elapsed = now - parseInt(start, 10);

    return Math.floor(elapsed / 1000);
  };

  const clearTimer = () => {
    window.clearInterval(intervalHandler);
    setIntervalHandler(null);

    if (store && isTimerFinished) {
      window.sessionStorage.removeItem(storageName);
    }
  };

  const clearTimerStorage = () => {
    if (store) {
      window.sessionStorage.removeItem(storageName);
    }
  };

  const updateTimer = () => {
    const elapsed = getElapsedTimeSeconds(startTime);
    if (elapsed >= timeoutSeconds) {
      setStartTime(null);
    }
  };

  const startTimer = () => {
    const interval = window.setInterval(() => {
      updateTimer();
    }, 1000);

    setIntervalHandler(interval);
  };

  const setTimer = () => {
    const storageStart = window.sessionStorage.getItem(storageName);

    let start = new Date().getTime();

    if (store && storageStart && getElapsedTimeSeconds(storageStart) <= timeoutSeconds) {
      start = storageStart;
    }

    setStartTime(start);
    if (store) {
      window.sessionStorage.setItem(storageName, start);
    }
  };

  useEffect(() => {
    if (startTime) {
      startTimer();
    } else if (startTime !== false) {
      clearTimer();
      setIsTimerFinished(true);
    }
  }, [startTime]);

  useEffect(() => {
    setTimer();

    return () => {
      clearTimer();
    };
  }, []);

  return {
    startTime,
    isTimerFinished,
    clearTimerStorage
  };
}

export { useTimer };
